const AVATAR_COLORS = [
  '#4f46e5', '#0891b2', '#16a34a', '#d97706',
  '#dc2626', '#9333ea', '#0d9488', '#ea580c',
  '#2563eb', '#db2777',
];

export function getInitials(name) {
  if (!name || typeof name !== 'string') return '?';
  // Words like "&" or "-" carry no initial.
  const parts = name.trim().split(/\s+/).filter((p) => /[\p{L}\p{N}]/u.test(p[0])).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || '').join('') || '?';
}

export function avatarColorFromName(name = '') {
  let hash = 0;
  const s = String(name);
  for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) | 0;
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
